'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = H3;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _heading = require('../heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function H3(props) {
  var children = props.children;


  return React.createElement(
    _heading2.default,
    (0, _extends3.default)({ component: 'h3', weight: 'semi-bold', size: 'small' }, props),
    children
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/h3/h3.js
// module id = 329
// module chunks = 114276838955818